import { useState, useEffect } from "react";
import useQuillImageTagSanitizer from "utilities/hooks/quill/use-quill-image-tag-sanitizer";
import StringUtils from "utilities/string-utils";

export default function useRichTextContent(
    unrestoredContent?: string,
    checkForChanged: boolean = false
) {
    const { sanitizeImageRichTextContent, restoreImageRichTextContent } =
        useQuillImageTagSanitizer();
    const [richTextContent, setRichTextContent] = useState("");
    const [contentRestored, setContentRestored] = useState(false);

    const serverSafeRichTextContent = (content: string) => {
        const sanitizedContent = sanitizeImageRichTextContent(content);
        return StringUtils.toServerSafeHtml(sanitizedContent);
    };

    useEffect(() => {
        if (checkForChanged && contentRestored) return;
        if (unrestoredContent == null || unrestoredContent === "") return;

        setContentRestored(true);

        (async () => {
            if (unrestoredContent == null || unrestoredContent === "") return;

            const restored =
                await restoreImageRichTextContent(unrestoredContent);
            const restoredWithLinks = StringUtils.toRenderableHtml(restored);

            setRichTextContent(restoredWithLinks);
        })();
    }, [
        contentRestored,
        unrestoredContent,
        restoreImageRichTextContent,
        checkForChanged,
    ]);

    return {
        contentRestored,
        setContentRestored,
        richTextContent,
        setRichTextContent,
        serverSafeRichTextContent,
    };
}
